import { Pipe, PipeTransform } from '@angular/core';
import { interval, map, Observable } from 'rxjs';

@Pipe({
  name: 'timer'
})
export class TimerPipe implements PipeTransform {

  transform(expiresOnUtc: string): Observable<string> {
    if (!expiresOnUtc) return new Observable<string>((observer) => observer.next(''));

    const expiry = new Date(expiresOnUtc).getTime();

    return interval(1000).pipe(
      map(() => {
        const now = Date.now();
        const diff = expiry - now;

        const absDiff = Math.abs(diff);
        const seconds = Math.floor((absDiff / 1000) % 60);
        const minutes = Math.floor((absDiff / (1000 * 60)) % 60);
        const hours = Math.floor((absDiff / (1000 * 60 * 60)) % 24);
        const days = Math.floor(absDiff / (1000 * 60 * 60 * 24));

        const timeStr =
          (days > 0 ? days + 'd ' : '') +
          (hours > 0 ? hours + 'h ' : '') +
          (minutes > 0 ? minutes + 'm ' : '') +
          seconds + 's';

        return diff >= 0 ? `${timeStr} left` : ``;
      })
    );
  }
}
